import { Box, Dialog } from '@radix-ui/themes'

import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { type Locale } from '#app/models/locale'
import { CartPopover } from '#app/routes/_layout/cart-popover'
import { type App } from '#app/routes/_layout/component.route.tsx'
import { MenuPopover } from '#app/routes/_layout/menu-popover'
import {
	ROOT_APP_VIEW,
	ROOT_I18NEXT,
} from '#app/routes/_layout/route-config.ts'

/* -------------------------------------------------------------------------------------------------
 * SidebarUI
 * -----------------------------------------------------------------------------------------------*/

type SidebarUIProps = {
	app: App
	locale: Locale
	setApp: React.Dispatch<React.SetStateAction<App>>
}

const SidebarUI: React.FC<SidebarUIProps> = ({ app, locale, setApp }) => {
	const [container, setContainer] = React.useState<HTMLDivElement | null>(null)
	const { t } = useTranslation(ROOT_I18NEXT.routeRoot)

	return (
		<Box className="app-SidebarUi">
			<Dialog.Root
				open={app.displaySidebar}
				onOpenChange={(action: boolean) =>
					setApp((prev) => ({ ...prev, displaySidebar: action }))
				}
			>
				<Dialog.Content container={container}>
					<Box hidden>
						<Dialog.Title>{t('sidebarUi.title')}</Dialog.Title>
						<Dialog.Description>
							{t('sidebarUi.description')}
						</Dialog.Description>
					</Box>
					{(() => {
						switch (app.sidebarView) {
							case ROOT_APP_VIEW.cartView:
								return <CartPopover app={app} locale={locale} setApp={setApp} />
							case ROOT_APP_VIEW.menuView:
								return <MenuPopover app={app} locale={locale} setApp={setApp} />
							default:
								return <></>
						}
					})()}
				</Dialog.Content>
			</Dialog.Root>
			<Box ref={setContainer} />
		</Box>
	)
}
SidebarUI.displayName = 'SidebarUI'

/* -----------------------------------------------------------------------------------------------*/

export { SidebarUI }
